import React from 'react';
import { Building01, Home01, Button } from '@opendate-app/setlist';
import crmLabels from '../../../shared/utils/crmLabels';

function AffiliationsCard({
  organizations = [],
  households = [],
  teamId,
  onViewHouseholds = () => {},
  onAddOrganization = () => {},
  onAddHousehold = () => {},
  labels = crmLabels(undefined),
}) {
  const orgSingularLower = labels.organization.singular.toLowerCase();
  const primaryOrg = organizations[0];
  const primaryHousehold = households[0];

  return (
    <div className="cdp-card">
      <h2 className="cdp-card-title">Affiliations</h2>

      <div className="cdp-affiliation-row">
        <Building01 width={16} height={16} className="cdp-affiliation-icon" aria-hidden="true" />
        {primaryOrg ? (
          <div>
            <div className="cdp-card-eyebrow">{labels.organization.singular}</div>
            <a href={`/teams/${teamId}/crm/organizations/${primaryOrg.id}`} className="cdp-affiliation-name">{primaryOrg.name}</a>
          </div>
        ) : (
          <Button variant="link-color" size="sm" onClick={onAddOrganization} aria-label={`Add ${orgSingularLower}`}>
            {`+ Add ${orgSingularLower}`}
          </Button>
        )}
      </div>

      <div className="cdp-affiliation-row">
        <Home01 width={16} height={16} className="cdp-affiliation-icon" aria-hidden="true" />
        {primaryHousehold ? (
          <div>
            <div className="cdp-card-eyebrow">Household</div>
            <button type="button" className="cdp-affiliation-name" onClick={onViewHouseholds}>
              {primaryHousehold.name || '(Unnamed household)'}
            </button>
          </div>
        ) : (
          <Button variant="link-color" size="sm" onClick={onAddHousehold} aria-label="Add household">
            + Add household
          </Button>
        )}
      </div>
    </div>
  );
}

export default AffiliationsCard;
